module.exports = __webpack_public_path__ + "static/media/frag01.68cb67ae.glsl";